export default {
  title: 'Tu sitio web está listo',
  body_one: 'Las reservas siguen desactivadas para {{count}} restaurante:',
  body_other: 'Las reservas siguen desactivadas para {{count}} restaurantes:',
  reasons: {
    license_required: 'Requiere un Plan Partner',
    notification_email_required:
      'Necesita un correo electrónico para las notificaciones de reservas. Añádelo al activar las reservas.',
    switched_off: 'Desactivado en la configuración de reservas',
    activation_failed: 'No se pudo activar. Inténtalo de nuevo en la configuración de reservas.',
  },
  buttons: {
    open_settings: 'Abrir configuración de reservas',
    continue: 'Continuar al creador de sitios web',
  },
};
